export default __webpack_public_path__ + "static/rocketship-hero-6791c30fa6f9980f8e6b43eb2bbf865f.svg";